import { render } from "./PublicFooter.vue?vue&type=template&id=45212798"
import script from "./PublicFooter.vue?vue&type=script&lang=js"
export * from "./PublicFooter.vue?vue&type=script&lang=js"

import "./PublicFooter.vue?vue&type=style&index=0&id=45212798&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/footer/PublicFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45212798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45212798', __exports__)) {
    api.reload('45212798', __exports__)
  }
  
  module.hot.accept("./PublicFooter.vue?vue&type=template&id=45212798", () => {
    api.rerender('45212798', render)
  })

}


export default __exports__